const searchInput = document.querySelector('.header-search__input-field');

if (searchInput) {
  const searchForm = document.querySelector('[data-search-form]');
  const searchContainer = document.querySelector('.header-search');

  const toggleSearchClass = (toggle) => {
    document.body.classList.toggle('is-open-search', toggle);

    if (windowWidth() > breakpointMd) {
      if (toggle) {
        searchContainer?.removeAttribute('inert');
      } else {
        searchContainer?.setAttribute('inert', '');
      }
    }

    if (toggle) {
      searchInput.focus();
      return;
    }

    searchInput.blur();
    searchForm.reset();
  };

  searchContainer?.addEventListener('focusout', (e) => {
    const next = e.relatedTarget;

    // If focus moves outside the search modal → close it
    if (!next || !searchContainer?.contains(next)) {
      toggleSearchClass(false);
      toggleBodyScrollLock(false);
      searchInput.value = '';
    }
  });

  attachEvent('.site-header__search-trigger', 'click', (ev) => {
    const isOpen = document.body.classList.contains('is-open-search');
    toggleSearchClass(!isOpen);
    toggleBodyScrollLock(!isOpen);
    ev.preventDefault();
  });

  attachEvent('[data-close-search]', 'click', (ev) => {
    toggleSearchClass(false);
    toggleBodyScrollLock(false);
    searchInput.value = '';
    ev.preventDefault();
  });

  // event listener for ESC key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleSearchClass(false);
      toggleBodyScrollLock(false);
      searchInput.value = '';
    }
  });
}
